<template>
    <div class="main">
        <div class="body-content">
            <div class="page-header">
                <h1>Codeco Coarri Report</h1>
            </div>
            <div class="form-group">
                <div class="form-item">
                    <label for="partyname">Party *</label>
                    <v-select :clearable="false" tabindex="0" placeholder="Select Party Name" id="partyname"
                        v-model="newContainer.partyName" :options="party" label="short_name"
                        :reduce="party => party.autoid" selectOnTab="True" />
                </div>

                <div class="form-item">
                    <label for="vesselName">Vessel *</label>
                    <v-select :clearable="false" id="vesselName" placeholder="Select Vessel"
                        v-model="newContainer.vesselID" ref="vesselName" :options="vessel" label="Name"
                        :reduce="vessel => vessel.Vesselid" selectOnTab="True" />
                </div>

                <div class="form-item">
                    <label for="voyageName">Voyage *</label>
                    <v-select :clearable="false" id="voyageName" v-model="newContainer.VoyId" :options="voyage"
                        label="Name" :reduce="voyage => voyage.Voyageid" selectOnTab="True" />
                </div>

                <div class="form-item">
                    <label for="movementname">Movement Type *</label>
                    <v-select :clearable="false" id="movementname" v-model="newContainer.movementID"
                        :options="movementOptions" label="Name" :reduce="movement => movement.Movid"
                        selectOnTab="True" />
                </div>
                <div class="form-item">
                    <label for="location">Location:</label>
                    <v-select :clearable="false" id="location" v-model="newContainer.locID" :options="location"
                        label="Name" :reduce="location => location.locationid" selectOnTab="True" />
                </div>
                <div class="form-item">
                    <label for="fromdate">From Date </label>
                    <input type="text" id="fromdate" v-model="newContainer.fromdate" placeholder="dd/mm/yyyy"
                        v-on:blur="checkIsDate()" />
                </div>
                <div class="form-item">
                    <label for="todate">To Date </label>
                    <input type="text" id="todate" v-model="newContainer.todate" placeholder="dd/mm/yyyy"
                        v-on:blur="checkIsToDate()" />
                    <!--<DatePicker v-model="formData.todate" :manualInput="true" dateFormat="dd/mm/yy" />-->
                </div>
                <div class="form-item">
                    <label for="location">Container(, Seperated):</label>
                    <textarea style="width: 100%;" v-model="newContainer.containerno" placeholder="Containerno"
                        rows="1"></textarea>
                </div>
            </div>
            <div class="form-item">
                <button type="button" class="excel-button" @click="codeco_coarri_report" :disabled="isSubmitting">Generate Report</button>
            </div>
            <div class="form-item">
                <div v-html="htmlContent"></div>
            </div>
        </div>
    </div>
</template>


<script>
import axios from 'axios';
//import { part } from 'core-js/core/function';
import VSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import { useToast } from 'vue-toastification';
import * as cs from '../assets/js/commonscript.js'

export default {
    components: {
        VSelect,
    },
    data() {
        return {
            transactions: [],
            party: JSON.parse(localStorage.getItem('party')),
            accounts: JSON.parse(localStorage.getItem('accounts')) || [],
            applicants: JSON.parse(localStorage.getItem('applicants')) || [],
            vessel: JSON.parse(localStorage.getItem('vessel')) || [],
            voyage: JSON.parse(localStorage.getItem('voyage')) || [],
            movementOptions: JSON.parse(localStorage.getItem('movements')) || [],
            ports: JSON.parse(localStorage.getItem('ports')) || [],
            location: JSON.parse(localStorage.getItem('Area')) || [],
            cfs_location: JSON.parse(localStorage.getItem('cfs_location')) || [],
            isSubmitting: false,
            newContainer: {
                partyName: 0,
                applicantID: 0,
                accountID: 0,
                vesselID: 0,
                VoyId: 0,
                movementID: 0,
                locID: 0,
                containerno: '',
                fromdate: '',
                todate: '',
            },
            htmlContent: null,
        }
    },
    methods: {
        checkIsDate() {
            if (this.newContainer.fromdate != '') {
                if (cs.isvalidDate(this.newContainer.fromdate) == false) {
                    useToast().error('Invalid From Date');
                }
            }
        },
        checkIsToDate() {
            if (this.newContainer.todate != '') {
                if (cs.isvalidDate(this.newContainer.todate) == false) {
                    useToast().error('Invalid To Date');
                }
            }
        },
        updateApplicantAccountIds(value) {
            const AppAcc = cs.GetAppAccFromParty(value)
            this.newContainer.applicantID = AppAcc.applicantid
            this.newContainer.accountID = AppAcc.accountid
        },
        handleFileUpload(event) {
            this.newContainer.file = event.target.files[0];
        },
        async codeco_coarri_report() {
            if (this.isSubmitting) return;
            
            // Validate required fields
            if (!this.newContainer.partyName) {
                useToast().error('Party is required.');
                return;
            }
            
            // Validate that either vessel+voyage OR from date+to date are provided
            const hasVesselAndVoyage = this.newContainer.vesselID && this.newContainer.VoyId;
            const hasFromAndToDate = this.newContainer.fromdate.trim() && this.newContainer.todate.trim();
            
            if (!hasVesselAndVoyage && !hasFromAndToDate) {
                useToast().error('Either Vessel & Voyage OR From Date & To Date must be provided.');
                return;
            }
            
            // Validate date format if dates are provided
            if (this.newContainer.fromdate && !cs.isvalidDate(this.newContainer.fromdate)) {
                useToast().error('Invalid From Date format. Please use dd/mm/yyyy.');
                return;
            }
            
            if (this.newContainer.todate && !cs.isvalidDate(this.newContainer.todate)) {
                useToast().error('Invalid To Date format. Please use dd/mm/yyyy.');
                return;
            }
            
            this.isSubmitting = true;
            
            try {
                this.updateApplicantAccountIds(this.newContainer.partyName);
                
                const token = localStorage.getItem('access_token');
                if (!token) {
                    useToast().error('Authentication token not found.');
                    return;
                }
                
                const config = {
                    headers: {
                        'accept': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                };
                
                var fromDt = '';
                var toDt = '';
                if (this.newContainer.fromdate != '') {
                    fromDt = cs.ConvertToISODate(this.newContainer.fromdate);
                }
                if (this.newContainer.todate != '') {
                    toDt = cs.ConvertToISODate(this.newContainer.todate);
                }
                
                const response = await axios.get('/codeco_corri_report?applicant=' + this.newContainer.applicantID + '&account=' + this.newContainer.accountID + '&vessel=' + this.newContainer.vesselID + '&voyage=' + this.newContainer.VoyId + '&location=' + this.newContainer.locID + '&movement=' + this.newContainer.movementID + '&fromdate=' + fromDt + '&todate=' + toDt, config);
                
                //console.log(response.data);
                if (response.data[0] === 0) {
                    useToast().error(response.data[1]);
                } else {
                    useToast().success(response.data[1]);
                }
            } catch (error) {
                console.error('Error generating Codeco Coarri report:', error);
                useToast().error(error.response?.data?.message || 'Error generating report.');
            } finally {
                this.isSubmitting = false;
            }
        }
    }
}
</script>


<style scoped>
/* Form group styling for form elements */
.form-group {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    margin-bottom: 5px;
}

.form-item {
    width: 23%;
}

select,
input[type="text"],
input[type="date"],
input[type="number"],
v-select {
    padding: 5px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
    background-color: #FFF;
}

.excel-button {
    background-color: #17a2b8;
    color: white;
    border: none;
    padding: 10px 15px;
    border-radius: 5px;
    cursor: pointer;
    margin-right: 10px;
}

.excel-button:disabled {
    background-color: #6c757d;
    cursor: not-allowed;
    opacity: 0.6;
}

.excel-button:disabled:hover {
    background-color: #6c757d;
}
</style>